import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";

import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function MachineEdit(props) {
    const {t} = useTranslation();
    const id = props.match.params.id;
    const name = useRef();
    const short_code = useRef();
    const model = useRef();
    const [machine, setMachine] = useState({});
    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get(API_URL + 'machine/' + id).then((response) => {
            if (response.data.status) {
                setMachine(response.data.data);
            } else {
                alertify.error(response.data.message);
            }
            setLoading(false);
        }).catch((error) => {
            alertify.error("Something went wrong. Try again!");
            setLoading(false);
        });
    }, [id]);

    const updateMachineHandler = (e) => {
        e.preventDefault();
        if (!name.current.value.trim()) {
            alertify.error(t("Machine name is required"));
            return;
        }
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + "machine/update", {
            id: id,
            name: name.current.value,
            short_code: short_code.current.value,
            model: model.current.value,
        }).then((response) => {
            setDisabled(0);
            setIconDisabled(1);
            if (response.data.status) {
                alertify.success(response.data.message);
                props.history.push("/machine/list");
            } else {
                alertify.error(response.data.message);
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            alertify.error("Something went wrong. Try again!");
        });
    };

    if (loading) {
        return (
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <div className="text-center py-5">
                                <i className="fas fa-spinner fa-spin fa-3x"></i>
                                <p className="mt-3">{t("Loading...")}</p>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    return (
        <>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader title={t("Edit Machine")}>
                            <CardHeaderToolbar>
                                <Link to="/machine/list" className="btn btn-primary btn-sm mx-3">
                                    {t("Machine List")}
                                </Link>
                            </CardHeaderToolbar>
                        </CardHeader>
                        <CardBody>
                            <div className="mt-3">
                                <Form onSubmit={updateMachineHandler}>
                                    <Form.Row>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Name")} <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                ref={name}
                                                defaultValue={machine.name}
                                                placeholder={t("Enter Machine Name")}
                                                required
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Short Code")}</Form.Label>
                                            <Form.Control
                                                ref={short_code}
                                                defaultValue={machine.short_code}
                                                placeholder={t("Enter Short Code")}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} md={4}>
                                            <Form.Label>{t("Model")}</Form.Label>
                                            <Form.Control
                                                ref={model}
                                                defaultValue={machine.model}
                                                placeholder={t("Enter Model")}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                        {t("Update Machine")}
                                        <span dangerouslySetInnerHTML={{__html: disabled ? ` <i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                    </Button>
                                </Form>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    );
}
